import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, createContext, useState, } from 'react';
import { Layout } from 'antd';
import { ApiConnection } from '@newtontechnologies/beey-api-js-client/connection';
import I18n from '../I18n/index.js';
import BeeyAppHeader from '../BeeyAppHeader/index.js';
import Localization from '../I18n/localization.js';
const { Content, Footer } = Layout;
export const SessionContext = createContext(undefined);
export const useSession = () => useContext(SessionContext);
const defaultLocalization = new Localization({}, 'en-US');
const BeeyApp = ({ name, version, icon, localization, children, }) => {
    const [connection] = useState(new ApiConnection());
    const layout = (_jsxs(Layout, { className: "beey-app-layout", children: [_jsx(BeeyAppHeader, { appName: name, appIcon: icon, locales: localization?.locales }), _jsx(Content, { children: children }), _jsxs(Footer, { children: [version !== null ? (_jsxs("p", { children: [name, ' ', "version", ' ', version] })) : null, _jsxs("p", { children: ["\u00A9 2021-", new Date().getFullYear(), " Beey by", ' ', _jsx("a", { href: "http://www.newtontech.net", target: "_blank", rel: "noreferrer", children: "Newton Technologies" })] })] })] }));
    return (_jsx(SessionContext.Provider, { value: { connection }, children: _jsx(I18n, { localization: localization ?? defaultLocalization, children: layout }) }));
};
export default BeeyApp;
